module.exports = __webpack_public_path__ + "static/media/whatsapp.d7ef0a60.svg";